export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13357.ad61bcc3.jpg";